import { useSelector } from 'react-redux';
import { HALLIBURTON_GLOBAL_FREIGHT_CUSTOMER_KEY } from '../../../contants/common';
import { useHelpCenter } from '../hooks/use-help-center-drawer';
import { ROUTING_MAP } from '../routes';
import { AuctionHelpCenterContent } from './auction/auction-help-center-content';
import { HelpCenterDrawer } from './help-center-drawer';
import { HelpCenterNotFound } from './help-center-not-found';
import { PurchaseOrderHelpCenterContent } from './purchase-order/purchase-order-help-center-content';
import { QuoteDashboardHelpCenterContent } from './quote-dasboard/quote-dashboard-help-center-content';
import { QuoteHelpCenterContent } from './quote/quote-help-center-content';
import { RoutingGuideHelpCenterContent } from './routing-guide/routing-guide-help-center-content';
import { ShipmentTrackingCarrierHelpCenterContent } from './shipment-tracking/shipment-tracking-help-center-content';
import { ShipmentHelpCenterContent } from './shipment/shipment-help-center-content';

export const HelpCenter = ({ isHBUser }) => {
  const { target, clearTarget } = useHelpCenter();

  const {
    user: { data: userDetails },
  } = useSelector((state) => state?.auth);
  const userType = userDetails?.userType;

  const { customerKey } = useSelector((state) => state?.auction?.auctionSearchFilters);

  const isHBGlobalFreightCustomerSelected = customerKey
    ?.split(',')
    ?.includes(`${HALLIBURTON_GLOBAL_FREIGHT_CUSTOMER_KEY}`);

  const DrawerContent = () => {
    if (isHBGlobalFreightCustomerSelected) {
      switch (target) {
        case ROUTING_MAP.auction: {
          if (userType === 'CARR') {
            return <AuctionHelpCenterContent />;
          }
          return <HelpCenterNotFound />;
        }

        default:
          return <HelpCenterNotFound />;
      }
    }

    if (isHBUser) {
      switch (target) {
        case ROUTING_MAP.quote: {
          return <QuoteHelpCenterContent />;
        }
        case ROUTING_MAP.routingGuide: {
          return <RoutingGuideHelpCenterContent />;
        }
        case ROUTING_MAP.dashboard: {
          return <QuoteDashboardHelpCenterContent />;
        }

        default:
          return <HelpCenterNotFound />;
      }
    }
    if (userType === 'CARR' && target === ROUTING_MAP.shipmentTracking) {
      return <ShipmentTrackingCarrierHelpCenterContent />;
    }
    if (userType === 'CUST' && target === ROUTING_MAP.shipment) {
      return <ShipmentHelpCenterContent />;
    }
    if (userType === 'VEND' && target === ROUTING_MAP.purchaseOrder) {
      return <PurchaseOrderHelpCenterContent />;
    }

    return <HelpCenterNotFound />;
  };

  return (
    <HelpCenterDrawer visible={target} handleCloseDrawer={clearTarget}>
      <DrawerContent />
    </HelpCenterDrawer>
  );
};
